// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal-overlay_overlay__AKixE"};